export default __webpack_public_path__ + "static/media/document.764c572f.webp";